type EnvironmentSpecificConfig = {
  API_URL: string;
};

const dev: EnvironmentSpecificConfig = {
  API_URL: 'http://localhost:8001/dev',
};
const test: EnvironmentSpecificConfig = {
  API_URL: 'https://0ivbh1vus3-vpce-05230a3b44834b6c7.execute-api.eu-central-1.amazonaws.com/test',
};

const prod: EnvironmentSpecificConfig = {
  API_URL: 'https://p2na8pks8l-vpce-029a257f23c61e79f.execute-api.eu-central-1.amazonaws.com/prod',
};

const env = process.env.REACT_APP_STAGE ?? 'dev';

const mergedConfig = {
  ...(env === 'dev' && dev),
  ...(env === 'test' && test),
  ...(env === 'prod' && prod),
  STANDALONE: env === 'dev',
};

export const MICROFRONTEND_ID = 'certificates';

export default mergedConfig;
